import React, {useState, useRef, useEffect} from 'react'
import PropTypes from 'prop-types'

import './CopyableCaseId.scss';
import { getI18nTextWithContext } from "wipi-common/src/lib/i18n";
import { useI18nContext } from "../i18n/I18nContext";
import { useTooltipRight } from "./TooltipRight";

export function CopyableCaseId({ caseId }) {
    const i18nContext = useI18nContext();
    const [, setCopied] = useState(false);
    const timerRef = useRef(null);
    const textRef = useRef(null);

    const {
        elementRef: buttonRef,
        setTooltipText,
        showTooltip,
        hideTooltip
    } = useTooltipRight(getI18nTextWithContext(i18nContext, 'copy.caseId.popup'));

    const copy = async () => {
        try {
            if (!textRef.current) return;

            const range = document.createRange();
            range.selectNodeContents(textRef.current);
            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);

            await navigator.clipboard.writeText(caseId);

            setCopied(true);
            setTooltipText(getI18nTextWithContext(i18nContext, 'common.copied'));
            showTooltip();

            timerRef.current = setTimeout(() => {
                setCopied(false);
                setTooltipText(getI18nTextWithContext(i18nContext, 'copy.caseId.popup'));
                hideTooltip();
                selection.removeAllRanges();
            }, 2000);
        } catch (err) {
            console.error('Error copiando texto:', err);
        }
    };

    useEffect(() => {
        return () => clearTimeout(timerRef.current);
    }, []);

    return (
        <div className="my-2 d-flex icon-container gap-3">
            <p className="m-0 justify-content-center"
                ref={textRef}
                data-test-id="d2dd9cf9-7a6g"
                title={getI18nTextWithContext(i18nContext, 'copy.caseId')}>
                 {caseId}
            </p>
            <button className="button-no-style"
                    ref={buttonRef}
                    onClick={copy}
                    aria-label={getI18nTextWithContext(i18nContext, 'copy.caseId.popup')}
                    data-bs-toggle="tooltip"
                    data-bs-placement="right"
                    data-bs-title={getI18nTextWithContext(i18nContext, 'copy.caseId.popup')}
            >
                <svg id="redCopyIcon" className="icon" width="20" height="20" viewBox="0 0 20 20" fill="none"
                    xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <g id="Vector">
                        <path d="M12 6H2C0.897 6 0 6.897 0 8V18C0 19.103 0.897 20 2 20H12C13.103 20 14 19.103 14 18V8C14 6.897 13.103 6 12 6Z"/>
                        <path d="M18 0H8C7.46957 0 6.96086 0.210714 6.58579 0.585786C6.21071 0.960859 6 1.46957 6 2V4H14C14.5304 4 15.0391 4.21071
                15.4142 4.58579C15.7893 4.96086 16 5.46957 16 6V14H18C18.5304 14 19.0391 13.7893 19.4142 13.4142C19.7893 13.0391 20
                12.5304 20 12V2C20 1.46957 19.7893 0.960859 19.4142 0.585786C19.0391 0.210714 18.5304 0 18 0Z" />
                    </g>
                </svg>
            </button>
        </div>
    );
}

CopyableCaseId.propTypes = {
    caseId: PropTypes.string.isRequired,
};
